import api from "./api.js";

export const rewardsHubService = {

    login: async (consumerId, phone) => {
        try {
            const payload = {
                consumer_id: consumerId,
                phone: phone,
            };

            // Goes through our backend; the api instance attaches the user's login JWT
            const response = await api.post("/dw/efu-login", payload);

            return response.data;
        } catch (error) {
            console.error("RewardsHub login error:", error);
            throw error;
        }
    },


    getRedeemedHistory: async (accessToken) => {
        try {
            const response = await api.post(
                "/dw/redeemed-history",
                {},
                { headers: { "x-dw-token": accessToken } }
            );

            return response.data;
        } catch (error) {
            console.error("RewardsHub get redeemed history error:", error.response || error);
            throw error;
        }
    },


    getCoinsHistory: async (page = 1, limit = 3) => {
        try {
            const response = await api.get(
                `/dw/coinshistory?page=${page}&limit=${limit}`
            );

            return response.data;
        } catch (error) {
            console.error("RewardsHub get coins history error:", error);
            throw error;
        }
    },

    getAllOffers: async (accessToken) => {
        try {
            const response = await api.get("/dw/offers", {
                headers: { "x-dw-token": accessToken },
            });

            return response.data;
        } catch (error) {
            console.error("RewardsHub get all offers error:", error);
            throw error;
        }
    },

    redeemVoucher: async (offerId, bearerToken, coinsToRedeem) => {
        try {
            const payload = {
                offer_id: offerId,
                bearer_token: bearerToken,
                coins_to_redeem: coinsToRedeem
            };

            const response = await api.post("/dw/redeemvoucher", payload);

            return response.data;
        } catch (error) {
            console.error("RewardsHub redeem voucher error:", error);
            throw error;
        }
    },
}; export default rewardsHubService;